const _excluded = ["items"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
const itemProps = ['selectedItem', 'selectedItems', 'defaultSelectedItem', 'defaultSelectedItems', 'initialSelectedItem', 'initialSelectedItems'];
const checkItems = _ref => {
  let {
    itemsToCheck,
    allItems,
    paramName
  } = _ref;
  if (!itemsToCheck) {
    return;
  }
  const itemsAsArray = Array.isArray(itemsToCheck) ? itemsToCheck : [itemsToCheck];
  const invalidItems = itemsAsArray.filter(item => !allItems.includes(item));
  if (invalidItems.length > 0 && process.env.NODE_ENV !== 'production') {
    const multiple = invalidItems.length > 1;
    console.warn('@adsk/alloy-react-dropdown:', "item".concat(multiple ? 's' : '', " provided to"), "'".concat(paramName, "'"), "".concat(multiple ? 'were' : 'was', " not referentially equal to any item in 'items' prop"), invalidItems);
  }
};
const isItem = item => !item.items;
export default (_ref2 => {
  let {
      items
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  if (process.env.NODE_ENV === 'production') {
    return;
  }
  const allItems = items.reduce((acc, curr) => {
    if (isItem(curr)) {
      acc.push(curr);
      return acc;
    } else {
      return [...acc, ...curr.items];
    }
  }, []);
  Object.keys(props).filter(key => itemProps.includes(key)).forEach(paramName => {
    checkItems({
      itemsToCheck: props[paramName],
      allItems,
      paramName
    });
  });
});
//# sourceMappingURL=checkReferenceEquality.js.map